import React, { useEffect, useState } from "react";
import Header from "./components/header/Header";
import Nav from "./components/nav/Nav";
import Experience from "./components/experience/Experience";
import Portfolio from "./components/portfolio/Portfolio";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import About from "./components/about/About";
import Loading from "./components/loading/Loading";

const App = () => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        let timer = setTimeout(() => setIsLoading(false), 2865);
        return () => {
            clearTimeout(timer);
        };
    }, []);

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    <Nav />
                    <Header />
                    <About />
                    <Experience />
                    <Portfolio />
                    <Contact />
                    <Footer />
                </>
            )}
        </>
    );
};

export default App;
